<template>
    <span class="page-modal">
        <a @click.prevent.stop="showModal = true" class="inner-content">
            <slot name="default"></slot>
        </a>

        <v-dialog v-model="showModal" v-if="showModal" scrollable :max-width="modalWidth">
            <v-card>
                <iframe :src="link" frameborder="0" width="100%" :height="modalHeight"></iframe>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="showModal = false">{{ 'Close' | translation }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<style>
    .page-modal .v-dialog__container {
        display: inline-block !important;
    }
</style>

<script>
    export default {
        name: 'PageModal',
        props: [
            'link',
            'modalWidth',
            'modalHeight'
        ],
        props: {
            link: String,
            modalWidth: {
                type: String,
                default: '800px',
            },
            modalHeight: {
                type: String,
                default: '600px',
            },
        },
        data() {
            return {
                showModal: false,
            };
        },
    };
</script>